import {Component, EventEmitter, Input, input, OnInit, Output} from '@angular/core';
import {MatButton, MatIconButton} from "@angular/material/button";
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {MatTooltip, TooltipPosition} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {LibSpinnerComponent} from "../../spinner/lib-spinner/lib-spinner.component";

@Component({
    selector: 'lib-button',
    standalone: true,
    imports: [
        MatButton,
        NgClass,
        NgTemplateOutlet,
        MatTooltip,
        MatIcon,
        MatProgressSpinner,
        MatIconButton,
        LibSpinnerComponent
    ],
    templateUrl: './lib-button.component.html',
    styleUrls: ['./lib-button.component.scss']
})
export class LibButtonComponent implements OnInit {

    @Input() disabled: boolean = false;
    @Input() iconClass: string;
    @Input() iconPosition: BUTTON_ICON_POSITION = BUTTON_ICON_POSITION.BEFORE;
    @Input() libType: BUTTON_TYPE = BUTTON_TYPE.BASIC;
    @Input() libSubType: BUTTON_SUB_TYPE = BUTTON_SUB_TYPE.PRIMARY;
    @Input() tooltipText: string;
    @Input() spinner = false;
    @Input() autoStopSpinner = true;
    @Input() svgUrl: string;
    @Input() matTooltipClass: string;
    @Input() matTooltipPosition: TooltipPosition = 'below';
    @Input() ariaLabel: string;
    @Input() selected = false;
    libChipVariant = input<BUTTON_CHIP_VARIANT>(BUTTON_CHIP_VARIANT.DEFAULT);
    ariaHasPopup = input<BUTTON_ARIA_POPUP | null>(null);
    ariaExpanded = input<boolean | null>(null);
    ariaChecked = input<boolean | null>(null);
    ariaPressed = input<boolean | null>(null);
    buttonRole = input<BUTTON_ROLE | null>(null);

    @Input() showBorder = true;

    @Output() buttonClick = new EventEmitter();
    BUTTON_TYPE = BUTTON_TYPE;
    BUTTON_SUB_TYPE = BUTTON_SUB_TYPE;
    BUTTON_ICON_POSITION = BUTTON_ICON_POSITION;
    BUTTON_CHIP_VARIANT = BUTTON_CHIP_VARIANT;

    constructor() {
    }

    ngOnInit(): void {
    }

    onClick(mouseEvent: MouseEvent): void {
        if (this.autoStopSpinner) {
            this.changeButtonState(true);
            setTimeout(() => this.changeButtonState(false), 1500);
        }
        this.buttonClick.emit(mouseEvent);
    }

    private changeButtonState(loading: boolean): void {
        this.spinner = loading;
    }
}

export enum BUTTON_TYPE {
    BASIC = 'basic',
    COMPACT = 'compact',
    LARGE = 'large',
    ROUNDED = 'rounded',
    ICON = 'icon',
    MEDIUM_ICON = 'mediumIcon',
    SMALL_ICON = 'smallIcon',
    ROUNDED_ICON = 'roundedIcon',
    LIST_ITEM = 'listItem',
    CHIP = 'chip',
    FAB = 'fab',
}

export enum BUTTON_SUB_TYPE {
    DEFAULT = 'default',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    DANGER = 'danger',
    DANGER_SECONDARY = 'danger-secondary',
    WARNING = 'warning',
    SUCCESS = 'success',
    GRADIENT = 'gradient',
    LIGHT = 'light',
    OUTLINED = 'outlined',
    DANGER_OUTLINED = 'danger-outlined',
    TEXT = 'text',
    CURRENT_COLOR = 'current-color'
}
export enum BUTTON_ICON_POSITION {
    BEFORE = 'before',
    AFTER = 'after'
}

export enum BUTTON_CHIP_VARIANT {
    DEFAULT = 'default',
    REACTION = 'reaction',
    REACTION_OPTION = 'reaction-option',
    REACTION_MORE_OPTION = 'reaction-more-option',
    REACTION_DETAIL = 'reaction-detail',
    EMOJI_CATEGORY = 'emoji-category',
    MESSAGE_ACTION = 'message-action',
    MESSAGE_REACTION = 'message-reaction'
}

export enum BUTTON_ARIA_POPUP {
    MENU = 'menu',
    DIALOG = 'dialog'
}

export enum BUTTON_ROLE {
    MENU_ITEM = 'menuitem',
    MENU_ITEM_RADIO = 'menuitemradio'
}
